import React, { useEffect, useRef, useState } from "react"
import { Form, Button, Card, Alert } from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link, useNavigate } from "react-router-dom"
import { updateUser, getUserData } from "../contexts/UsersContext"


export default function UpdateProfile() {
  const emailRef = useRef()
  const passwordRef = useRef()
  const passwordConfirmRef = useRef()
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [phoneNumber, setPhoneNumber] = useState("")
  const [city, setCity] = useState("")
  const [street, setStreet] = useState("")
  const [houseNumber, setHouseNumber] = useState("")
  const [preChangeDetails] = useState([])
  const { currentUser, updatePassword, updateEmail } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  
  const navigate = useNavigate();
  useEffect(()=>{
    const fetchUser = async () => {
      const user = await getUserData(currentUser.email);  
      setFirstName(user.first_name);
      preChangeDetails.push(user.first_name)
      setLastName(user.last_name);
      preChangeDetails.push(user.last_name)
      setPhoneNumber(user.phone_number);
      preChangeDetails.push(user.phone_number)
      setCity(user.city);
      preChangeDetails.push(user.city)
      setStreet(user.street);
      preChangeDetails.push(user.street)
      setHouseNumber(user.house_number);
      preChangeDetails.push(user.house_number)
    }
    fetchUser().catch(console.error);
  }, [currentUser.email]);
  
  async function handleSubmit(e) {
    e.preventDefault()
    if (passwordRef.current.value !== passwordConfirmRef.current.value) {
      return setError("Passwords do not match")
    }

    const promises = []
    setLoading(true)
    setError("")

    if (emailRef.current.value !== currentUser.email) {
      promises.push(updateEmail(emailRef.current.value))
    }
    if (passwordRef.current.value) {
      promises.push(updatePassword(passwordRef.current.value))
    }
    
    const refs = [firstName, lastName, phoneNumber, city, street, houseNumber]
    const finalDetails = []
    var changeNeeded = false
    for (let i = 0; i < preChangeDetails.length; i++) {
      if (refs[i] && refs[i] !== preChangeDetails[i]){
        finalDetails.push(refs[i]);
        changeNeeded = true;
      }
      else{
        finalDetails.push(preChangeDetails[i]);
      }
    }
    console.log("fianlDetails:", finalDetails);
  if (changeNeeded){
    await updateUser(currentUser.email, finalDetails);
  }

    Promise.all(promises)
      .then(() => {
        navigate("/")
      })
      .catch(() => {
        setError("Failed to update account")
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <>
      <Card>
        <Card.Body>
          <h2 className="text-center mb-4">Update Profile</h2>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group id="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                ref={emailRef}
                required
                disabled
                defaultValue={currentUser.email}
              />
            </Form.Group>
            <Form.Group id="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                ref={passwordRef}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            <Form.Group id="password-confirm">
              <Form.Label>Password Confirmation</Form.Label>
              <Form.Control
                type="password"
                ref={passwordConfirmRef}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            <Form.Group id="first-name">
              <Form.Label>First Name</Form.Label>
              <Form.Control
                type="first-name"
                defaultValue={firstName}
                onChange={(e)=>setFirstName(e.target.value)}
                placeholder="Leave blank to keep the same"
              />
              </Form.Group>
            <Form.Group id="last-name">
              <Form.Label>Last Name</Form.Label>
              <Form.Control
                type="last-name"
                defaultValue={lastName}
                onChange={(e)=>setLastName(e.target.value)}
                placeholder="Leave blank to keep the same"
              />
              </Form.Group>
            <Form.Group id="phone-number">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="phone-number"
                defaultValue={phoneNumber}
                onChange={(e)=>setPhoneNumber(e.target.value)}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            <Form.Group id="city">
              <Form.Label>City</Form.Label>
              <Form.Control
                defaultValue={city}
                onChange={(e)=>setCity(e.target.value)}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            <Form.Group id="street">
              <Form.Label>Street</Form.Label>
              <Form.Control
                defaultValue={street}
                onChange={(e)=>setStreet(e.target.value)}
                placeholder="Leave blank to keep the same"
              />
              <Form.Group id="house-number">
              <Form.Label>House Number</Form.Label>
              <Form.Control
                defaultValue={houseNumber}
                onChange={(e)=>setHouseNumber(e.target.value)}
                placeholder="Leave blank to keep the same"
              />
            </Form.Group>
            </Form.Group>
            <Button disabled={loading} className="w-100" type="submit">
              Update
            </Button>
          </Form>
        </Card.Body>
      </Card>
      <div className="w-100 text-center mt-2">
        <Link to="/">Cancel</Link>
      </div>
    </>
  )
}